import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconBed: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
        xmlns: 'http://www.w3.org/2000/svg',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M21 12.8V6C21 4.3 19.7 3 18 3H6C4.3 3 3 4.3 3 6V12.8C2.4 13.3 2 14.1 2 15V21C2 21.6 2.4 22 3 22C3.6 22 4 21.6 4 21V20H20V21C20 21.6 20.4 22 21 22C21.6 22 22 21.6 22 21V15C22 14.1 21.6 13.3 21 12.8ZM5 6C5 5.4 5.4 5 6 5H18C18.6 5 19 5.4 19 6V12H18V8C18 7.4 17.6 7 17 7H12H7C6.4 7 6 7.4 6 8V12H5V6ZM8 12V9H11V12H8ZM13 9H16V12H13V9ZM4 18V15C4 14.4 4.4 14 5 14H7H12H17H19C19.6 14 20 14.4 20 15V18H4Z',
    })
  )
}
